import { GroupedSelectGroup } from '@/components/Form/GroupedSelect';

import {
  IndiciaReasonCode,
  TaxEntryType,
  TaxInfoEntry,
  TaxInfoRequestPayload,
} from '@/types/api/tax-info';
import { TranslatorFunction } from '@/types/i18n';

import { ForeignIndiciaCountryDetail } from '@/utils/user';

import {
  QUESTION_2_TAX_ENTRY_TYPES,
  replaceOwnedTaxEntries,
} from '../utils/taxInfoStatus';
import { OtherCountriesTaxFormValues } from '../utils/types';
import { FOREIGN_INDICIA_REASON_GROUPS } from './constants';

export function getForeignIndiciaGroupedSelectConfig(t: TranslatorFunction) {
  const groups: GroupedSelectGroup[] = FOREIGN_INDICIA_REASON_GROUPS.map(
    group => ({
      id: group.id,
      subheading: t(group.subheadingKey),
      options: group.optionCodes.map(code => ({
        value: code,
        label: t(`taxInfoDrawer.question2.foreignIndicia.options.${code}`),
      })),
    }),
  );

  return {
    groups,
    otherOption: {
      value: IndiciaReasonCode.OTHER,
      label: t(
        `taxInfoDrawer.question2.foreignIndicia.options.${IndiciaReasonCode.OTHER}`,
      ),
    },
  };
}

function buildForeignIndiciaExplanationEntry(
  countryCode: string,
  formValues: OtherCountriesTaxFormValues,
): TaxInfoEntry {
  const indiciaReasonCode = formValues.indiciaReasonCode?.[countryCode];

  return {
    countryCode,
    taxEntryType: TaxEntryType.FOREIGN_INDICIA_EXPLANATION,
    isCompleted: true,
    indiciaReasonCode,
    ...(indiciaReasonCode === IndiciaReasonCode.OTHER
      ? { indiciaReasonOther: formValues.indiciaReasonOther?.[countryCode] }
      : {}),
  };
}

export function buildForeignIndiciaExplanationPayload(
  formValues: OtherCountriesTaxFormValues,
  foreignIndiciaCountries: ForeignIndiciaCountryDetail[],
  existingTaxInfo?: TaxInfoEntry[],
): TaxInfoRequestPayload {
  const explanationEntries = foreignIndiciaCountries.map(({ countryCode }) =>
    buildForeignIndiciaExplanationEntry(countryCode, formValues),
  );
  return replaceOwnedTaxEntries(existingTaxInfo ?? [], explanationEntries, [
    ...QUESTION_2_TAX_ENTRY_TYPES,
  ]);
}
